module.exports = __webpack_public_path__ + "static/media/in-the-beginning-was-the-word_1.960d318b.jpg";